// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { SourceComponent } from "./source-component";
import { TraceEvent, TraceEventT, verifyTraceEvent } from "./trace-event";
import { U128, U128T, verifyU128 } from "../u128/u128";

/**
 * Batch of trace events sent over TCP/WebSocket.
 */
export class TraceEventBatch implements flatbuffers.IUnpackableObject<TraceEventBatchT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TraceEventBatch {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTraceEventBatch(
    bb: flatbuffers.ByteBuffer,
    obj?: TraceEventBatch,
  ): TraceEventBatch {
    return (obj || new TraceEventBatch()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsTraceEventBatch(
    bb: flatbuffers.ByteBuffer,
    obj?: TraceEventBatch,
  ): TraceEventBatch {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TraceEventBatch()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static bufferHasIdentifier(bb: flatbuffers.ByteBuffer): boolean {
    return bb.__has_identifier("LNT2");
  }

  source(): SourceComponent {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SourceComponent.Wvs;
  }

  testRunId(obj?: U128): U128 | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new U128()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  events(index: number, obj?: TraceEvent): TraceEvent | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new TraceEvent()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  eventsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startTraceEventBatch(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addSource(builder: flatbuffers.Builder, source: SourceComponent) {
    builder.addFieldInt8(0, source, SourceComponent.Wvs);
  }

  static addTestRunId(builder: flatbuffers.Builder, testRunIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, testRunIdOffset, 0);
  }

  static addEvents(builder: flatbuffers.Builder, eventsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, eventsOffset, 0);
  }

  static createEventsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startEventsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endTraceEventBatch(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // test_run_id
    builder.requiredField(offset, 8); // events
    return offset;
  }

  static finishTraceEventBatchBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset, "LNT2");
  }

  static finishSizePrefixedTraceEventBatchBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset, "LNT2", true);
  }

  unpack(): TraceEventBatchT {
    return new TraceEventBatchT(
      this.source(),
      this.testRunId() !== null ? this.testRunId()!.unpack() : null,
      this.bb!.createObjList<TraceEvent, TraceEventT>(this.events.bind(this), this.eventsLength()),
    );
  }

  unpackTo(_o: TraceEventBatchT): void {
    _o.source = this.source();
    _o.testRunId = this.testRunId() !== null ? this.testRunId()!.unpack() : null;
    _o.events = this.bb!.createObjList<TraceEvent, TraceEventT>(
      this.events.bind(this),
      this.eventsLength(),
    );
  }

  unpackFields(...fields: string[]): TraceEventBatchT {
    const t = new TraceEventBatchT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("source")) {
      t.source = this.source();
    }
    if (fieldSet.has("test_run_id")) {
      t.testRunId = this.testRunId() !== null ? this.testRunId()!.unpack() : null;
    }
    if (fieldSet.has("events")) {
      t.events = this.bb!.createObjList<TraceEvent, TraceEventT>(
        this.events.bind(this),
        this.eventsLength(),
      );
    }
    return t;
  }
}

export class TraceEventBatchT implements flatbuffers.IGeneratedObject {
  constructor(
    public source: SourceComponent = SourceComponent.Wvs,
    public testRunId: U128T | null = null,
    public events: TraceEventT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.testRunId === null || this.testRunId === undefined) {
      throw new Error('Required field "test_run_id" is not set');
    }
    if (this.events === null || this.events === undefined) {
      throw new Error('Required field "events" is not set');
    }
    const testRunId = this.testRunId !== null ? this.testRunId!.pack(builder) : 0;
    const events = TraceEventBatch.createEventsVector(
      builder,
      builder.createObjectOffsetList(this.events),
    );

    TraceEventBatch.startTraceEventBatch(builder);
    TraceEventBatch.addSource(builder, this.source);
    TraceEventBatch.addTestRunId(builder, testRunId);
    TraceEventBatch.addEvents(builder, events);

    return TraceEventBatch.endTraceEventBatch(builder);
  }

  clone(): TraceEventBatchT {
    const obj = new TraceEventBatchT();
    obj.source = this.source;
    obj.testRunId = this.testRunId !== null ? this.testRunId!.clone() : null;
    obj.events = this.events.map((e) => e.clone());
    return obj;
  }

  equals(other: TraceEventBatchT): boolean {
    if (this.source !== other.source) return false;
    if (this.testRunId !== null && other.testRunId !== null) {
      if (!this.testRunId!.equals(other.testRunId!)) return false;
    } else if (this.testRunId !== other.testRunId) return false;
    if (this.events.length !== other.events.length) return false;
    for (let i = 0; i < this.events.length; i++) {
      const a = this.events[i];
      const b = other.events[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyTraceEventBatch(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyU128(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "test_run_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyTraceEvent);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "events");
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsTraceEventBatch(
  buf: DataView,
  opts?: flatbuffers.VerifierOptions,
): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyTraceEventBatch(verifier, tablePos);
}
